define('components/handlers/kyc-report/bulk-compliance-order',[
    'jquery',
], function ($) {
    $.extend(companyInfo.handlers, {
        'kyc-report-compliance-order': function () {
            var orderButton = $(this);
            var spinner = $("#compliance-order-spinner");
            var dossierID = $('input[name="dossier-id"]').first().val();
            var subDossierID = $('input[name="sub-dossier-id"]').first().val();

            // replace button with spinner
            orderButton.addClass("hidden");
            orderButton.removeClass("submit"); // don't know why, but this is apparently needed to get the element to disappear
            spinner.removeClass("hidden");
            // get all the checked boxes and place document orders at the API
            var results = placeDocumentOrders(dossierID, subDossierID);
            var promises = results[0];
            var checkboxIDs = results[1];
            // then wait until all the orders are finished (the poll function re-enables the order button)
            Promise.all(promises).then(function () {
                    pollReportUntilOrdersAreFinished(dossierID, orderButton, spinner, checkboxIDs);
                }
            );

            function placeDocumentOrders(dossierID, subDossierID) {
                var promises = [];
                var checkboxIDs = []; // we track the checkbox IDs that require an update
                $("[data-compliance-screen]").filter(':checked').filter(":not(:disabled)").each(function () {
                    var checkBox = $(this);
                    checkboxIDs.push(checkBox.attr('id'));
                    checkBox.attr("disabled", true);
                    var reference = checkBox.data("item-reference");
                    var screeningType = checkBox.data("item-type"); // persons or organisations
                    var name = checkBox.data("item-name");
                    var birthdate = checkBox.data("item-birthdate");

                    promises.push(fetch('/kyc/reports/' + dossierID + '/documents/compliance/orders', {
                        method: 'POST',
                        headers: {'Content-Type': 'application/json'},
                        body: JSON.stringify({
                            reference: reference,
                            name: name,
                            type: screeningType,
                            birthDate: birthdate,
                            subDossierID: subDossierID
                        })
                    }).then(function (response) {
                        if (!response.ok) {
                            checkBox.siblings("[data-failure]").first().removeClass("hidden");
                            checkBox.addClass("hidden");
                            // todo; possibly add user friendly explanation, for now this is ok
                        }
                    }).catch(function (err) {
                        checkBox.siblings("[data-failure]").first().removeClass("hidden");
                        checkBox.addClass("hidden");
                    }));
                });
                return [promises, checkboxIDs];
            }

            function pollReportUntilOrdersAreFinished(reportID, orderButton, spinner, checkboxIDs) {
                fetch('/kyc/reports/' + reportID + '/json').then(function (res, rej) {
                    if (res.ok) {
                        res.json().then(function (report) {
                            var numOrdersInProgress = 0;
                            numOrdersInProgress += updateComplianceRecords(report.complianceScreening.organizations, 'organisations', checkboxIDs);
                            numOrdersInProgress += updateComplianceRecords(report.complianceScreening.persons, 'persons', checkboxIDs);
                            if (numOrdersInProgress !== 0) {
                                // call recursively after 5 seconds until all orders are done
                                wait(5000).then(
                                    function (res, rej) {
                                        pollReportUntilOrdersAreFinished(reportID, orderButton, spinner, checkboxIDs);
                                    });
                            }
                            // this if-statement is needed because of the lack of 'await'
                            if (numOrdersInProgress === 0) {
                                // once all orders are done the recursion should stop and we hit this part where we
                                // make the order button available again
                                spinner.addClass("hidden");
                                orderButton.removeClass("hidden");
                                orderButton.addClass("submit");
                            }
                        });
                    } else {
                        // todo; I really don't know how to error handle everything yet, lets not do it for now in v0.1
                        return rej();
                    }
                }).catch(function (err) {
                    console.log(err);
                });
            }

            // Given a list of persons or organizations; update the UI accordingly.
            // We track how many orders are still in progress to see if we can break the recursion or not.
            function updateComplianceRecords(complianceEntries, documentType, checkboxIDs)  {
                var numOrdersInProgress = 0;
                complianceEntries.forEach(function (complianceEntry) {
                    // means the user didn't order anything for this company/person
                    if (complianceEntry.order === null) {
                        return;
                    }

                    // in progress means the UI doesn't need updating
                    if (complianceEntry.order != null && complianceEntry.order.status === "processing") {
                        numOrdersInProgress += 1;
                        return;
                    }

                    updateComplianceRecord(complianceEntry, documentType, checkboxIDs);
                });
                return numOrdersInProgress;
            }

            // For every row (organization or person) in the compliance table, this function is called.
            // It in turn tries to update the UI for every row that could be screened.
            function updateComplianceRecord(complianceEntry, documentType, checkboxIDs) {
                var baseIdentifier = complianceEntry.id + '_' + documentType;
                var checkBoxID = baseIdentifier + '_checkbox';
                // if this checkbox is not in the list it means it is an item that was already processed/finished; just return.
                // otherwise the UI keeps adding rows to the table.
                var index = checkboxIDs.indexOf(checkBoxID);
                if(index === -1) {
                    return;
                }

                checkboxIDs.splice(index, 1); // mark the checkbox as processed by removing it from the list
                // hide checkbox
                var checkBox = $("#" + checkBoxID);
                checkBox.addClass("hidden");
                if (complianceEntry.order.status === "failed") {
                    var errorResultSpan = $("#" + baseIdentifier + '_error_result');
                    errorResultSpan.removeClass("hidden");
                    return;
                }
                if (complianceEntry.order.status === "finished" && (complianceEntry.order.searchResults === null || complianceEntry.order.searchResults.length === 0)) {
                    var noResultsSpan = $("#" + baseIdentifier + '_no_results');
                    noResultsSpan.removeClass("hidden");
                    return;
                }

                var rowID = baseIdentifier + '_row';
                var originalRow = document.getElementById(rowID); // now we insert all records after this
                complianceEntry.order.searchResults.reverse().forEach( // reverse list first since it is ordered on highest score first.
                    function(item, index) {
                        // don't hate me for this, string formatting is not in this version of JS
                        var countries = "";
                        if(item.countries != null) {
                            countries = item.countries.join(", ");
                        }
                        var html = '<tr><td><span class="compliance-result-indent">' + item.name + '</span></td>' +
                                '<td></td><td class="compliance-report-result-text-align">' + countries + '</td>' +
                                '<td class="compliance-report-result-text-align">' + item.score + '</td>' +
                                getComplianceCellResult(item.isPep) + getComplianceCellResult(item.isSanctioned) +
                                getComplianceCellResult(item.isMedia) + '</tr>';
                        originalRow.insertAdjacentHTML("afterend", html);
                    }
                );
            }

            function wait(ms) {
                return new Promise(function (res, rej) {
                    setTimeout(res, ms);
                });
            }

            function getComplianceCellResult(input) {
                if(input === true) {
                    return '<td><img src="/gui/img/compliance/highrisk.svg" alt="highrisk" class="compliance-risk-image compliance-report-result-text-align"/></td>';
                }
                return '<td></td>';
            }

        },
    });

});

